// extracted by mini-css-extract-plugin
module.exports = {"rootWrapper":"_3YiVOVREwL7H63h2hCwHe","hideScrollBar":"_2hGL0M8lb0G1QuNqEGHsX1"};